import earth from '@/assets/images/amazonia-1-1-1024x677.webp'
import blockChainImage from '@/assets/images/blockchain.webp'
import card from '@/assets/images/card-tecnologia-01.webp'
import imageOfCooperation from '@/assets/images/cooperacao-universidades.webp'
import diagrama from '@/assets/images/diagrama-por.webp'
import hydro from '@/assets/images/HydroGNSS.webp'
import microservicesImage from '@/assets/images/microservices-architecture.webp'
import monitoringImage from '@/assets/images/monitoramento.webp'
import researchImage from '@/assets/images/pesquisas-avancadas.webp'
import processing from '@/assets/images/processamento.webp'
import cloud from '@/assets/images/processamento-nuvem.webp'
import quantumImage from '@/assets/images/quantico.webp'
import satelliteImage from '@/assets/images/satelite.webp'
import smartContratos from '@/assets/images/smart-contracts-1024x589.webp'
import transactionsImage from '@/assets/images/transacoes-seguras.webp'
import { BannerWithTitle } from '@/components/banner-with-title'

import { CardImage } from './card-image'

export function Technologies() {
  const cards = [
    {
      image: smartContratos,
      content:
        'Smart contracts conectando patrocinadores e conservadores ambientais',
    },
    {
      image: earth,
      content:
        'Imagens de ultra alta resolução usando vários comprimentos de onda de luz e radar',
    },
    {
      image: hydro,
      content: 'Satélites de baixa órbita de última geração',
    },
    {
      image: blockChainImage,
      content:
        'Blockchain, deep learning, inteligência artificial e oráculos exclusivos',
    },
    {
      image: processing,
      content:
        'Centro de processamentos 6BIOS redundantes em três continentes distintos',
    },
    {
      image: quantumImage,
      content:
        'Algoritmos quânticos de cálculo ambiental e climático exclusivos',
    },
    {
      image: monitoringImage,
      content:
        'Monitoramento certificando a preservação em modo multiespectral',
    },
    {
      image: transactionsImage,
      content: 'Transações seguras e criptografadas, registradas em blockchain',
    },
    {
      image: microservicesImage,
      content:
        'Algorítimos de cálculo ambiental exclusivos e registrados pela 6BIOS',
    },
    {
      image: imageOfCooperation,
      content:
        'Acordos de cooperação técnica e científica com grandes universidades',
    },
    {
      image: researchImage,
      content:
        'Pesquisas avançadas e inéditas em supercomputação quântica ambiental junto com as mais importantes universidades',
    },
    {
      image: card,
      content:
        'Plataforma de conexão permitindo ao patrocinador acompanhar diretamente suas contribuições e áreas patrocinadas',
    },
    {
      image: satelliteImage,
      content: 'Satélites geoestacionários posicionados sobre o Brasil',
    },
    {
      image: cloud,
      content: 'Processamento em nuvem e arquitetura de microsserviços',
    },
  ]

  return (
    <div className="content-container">
      <BannerWithTitle
        title="Como funciona a plataforma de pagamentos"
        className="bg-technologies"
      />

      <div className="mt-10 space-y-16 xl:mt-16 2xl:mt-20 2xl:space-y-20">
        <div className="space-y-5 px-5 text-center md:text-start xl:space-y-8 xl:px-40 2xl:space-y-10 2xl:px-72">
          <div className="space-y-6">
            <p className="paragraph">
              A 6BIOS emprega um complexo conjunto de softwares construídos em
              arquitetura de micro serviços que são processados localmente ou em
              nuvem, hospedados em servidores redundantes instalados em
              diferentes partes do planeta.
            </p>
            <p className="paragraph">
              Estes softwares fazem uso de redes criptografadas do tipo
              blockchain que guardam contratos inteligentes com os dados dos
              preservadores, patrocinadores, reservas ambientais e valores de
              patrocínios. Estes contratos eletrônicos automatizados consultam
              módulos de software híbridos denominados oráculos que residem
              parte dentro da blockchain e parte conectados a um complexo
              conjunto de informações ambientais envolvendo imagens de satélite
              multiespectrais de alta resolução, dados oficiais de propriedades,
              certificadores de biomas, entre vários outros.
            </p>
            <p className="paragraph">
              Utilizando inteligência artificial e deep learning monitoram e
              confirmam as condições ambientais dos biomas onde estão as
              reservas de patrimônio natural e, em caso de comprovada
              preservação, transferem os recursos financeiros aportados pelos
              patrocinadores e custodiados nas mais seguras instituições
              financeiras do mundo para os preservadores.
            </p>
            <p className="paragraph">
              As decisões de inteligência artificial tomada pelos oráculos fazem
              uso de algoritmos exclusivos da 6BIOS de alta performance que
              combinam as informações recebidas e produzem resultados de
              altíssima precisão.
            </p>
            <p className="paragraph">
              A 6BIOS também é pioneira no uso de tecnologia quântica para
              processamento de informações ambientais, sendo a primeira empresa
              do mundo a empregar esta sofisticada tecnologia em uma plataforma
              de pagamentos para preservadores.
            </p>
            <p className="paragraph">
              Toda esta alta complexidade é completamente invisível para os
              usuários da plataforma que acessam este poderoso conjunto de
              recursos através de um app disponível nas plataformas Apple e
              Android. Os patrocinadores podem acompanhar do seu smartphone tudo
              o que acontece nas reservas ambientais sob seu patrocínio a até
              receber certificados acreditados das suas ações de preservação
              ambiental. Do mesmo modo os preservadores podem utilizar a
              plataforma para cadastrar suas áreas de preservação e acompanhar
              todos os recebimentos dos valores de patrocínios pactuados em seus
              contratos.
            </p>
          </div>
        </div>
        <img
          className="border-bios-light mx-auto rounded-lg border"
          src={diagrama}
          alt="Diagrama com os passos que 6bios utiliza"
        />
        <div className="title-with-paragraph">
          <h1 className="title">O estado da arte em tecnologias ambientais</h1>
          <div className="space-y-6">
            <p className="paragraph">
              A equipe da 6Bios, incluindo seus cientistas, pesquisadores e
              engenheiros e técnicos, são ligados aos principais centro de
              tecnologia computacional e ambiental. A partir de convênios de
              cooperação, estreita colaboração técnica e científica com
              instituições de pesquisa e universidades renomadas, desenvolve o
              estado da arte em ciência e tecnologia.
            </p>
            <p className="paragraph">
              Nossos algoritmos de monitoração ambiental são exclusivos e
              registrados ou patenteados, constituindo um patrimônio intangível
              dedicado à tecnologia ambiental e focado na preservação dos biomas
              brasileiros. São códigos e softwares para cálculo de sequestro de
              carbono, preservação e evolução de biomas,
            </p>
            <p className="paragraph">
              regeneração ambiental, processamento de imagens de satélite
              multiespectrais e contratos de patrocínio inteligentes (smart
              contracts) que executam pagamentos automáticos para os
              preservadores ambientais de forma transparente e auditada,
              registrados em redes blockchain e conectados ao mundo físico
              através de oráculos de última geração.
            </p>
            <p className="paragraph">
              Abaixo apresentamos uma breve relação das tecnologias utilizadas
              no dia a dia da operação da 6BIOS.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 xl:px-24 2xl:px-60">
          {cards.map((item) => (
            <CardImage
              key={item.image}
              image={item.image}
              content={item.content}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
